import { SuccessResponse } from '@/types'
import { CreateTankHistoryRequest } from '@/types/apis/tankHistory/CreateTankHistoryRequest'
import { GetAllTankHistoryRequest } from '@/types/apis/tankHistory/GetAllTankHistoriesRequest'
import { GetAllTankHistoryResponse } from '@/types/apis/tankHistory/GetAllTankHistoriesResponse'

import axios from './axios'

const API_ENDPOINT = '/tank/history'

export const getAllTankHistoriesApi = (request: GetAllTankHistoryRequest): Promise<GetAllTankHistoryResponse> => {
  return axios.get(`${API_ENDPOINT}`, { params: request })
}

export const createTankHistoryApi = (request: CreateTankHistoryRequest): Promise<SuccessResponse> => {
  return axios.post(`${API_ENDPOINT}`, request)
}
